import { useEffect } from "react";

const useScrollToElement = (elementRef, options) => {
  useEffect(() => {
    if (elementRef && elementRef.current) {
      elementRef.current.scrollIntoView(options);
    }
  }, [elementRef, options]);
};

export default useScrollToElement;
